/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantApiKeysCreate } from "../../funcs/tenantApiKeysCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysRequestBody$inboundSchema,
};

export const tool$tenantApiKeysCreate: ToolDefinition<typeof args> = {
  name: "tenant-api-keys_create",
  description: `Create a new tenant API key

Creates a new API key for a tenant with specified permissions`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantApiKeysCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
